import {
  ChangeDetectorRef,
  Component,
  ComponentRef,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { TicketManager } from '@routes/ticket-manager';
import { Ticket } from '@routes/ticket-manager/ticket';
import { finalize, takeWhile } from 'rxjs/operators';
import { Router } from '@angular/router';
import { TicketEditComponent } from '@routes/tickets/ticket-edit/ticket-edit.component';
import { ApiService } from '@shared/apis';
import * as _ from 'lodash-es';
import { SpinnerService } from '@shared/services/spinner.service';

@Component({
  selector: 'app-tickets',
  templateUrl: './tickets.component.html',
  styleUrls: ['./tickets.component.scss']
})
export class TicketsComponent implements OnInit, OnDestroy {

  ticket: Ticket;

  loadComponents: any[] = [];

  componentFactory: any;

  private alive = true;

  @ViewChild('ticketContainer', { read: ViewContainerRef }) private container: ViewContainerRef;

  /*@HostListener('window:beforeunload', ['$event'])
  public beforeunloadHandler($event) {
    $event.returnValue = 'Are you sure?';
  }*/

  constructor(private router: Router,
              private renderer2: Renderer2,
              private cdRef: ChangeDetectorRef,
              private apiService: ApiService,
              private spinnerService: SpinnerService,
              private ticketManager: TicketManager) {

    const url = router.url.split('/');
    const ticketNo = _.last(url);
    if (url.includes('tickets') && !this.loadComponents.length && ticketNo !== 'tickets') {
      const isNew = url.includes('new');
      const ticketInfo: any = {
        ticketNo,
        status: isNew ? 'new' : null,
        reload: isNew,
      };

      if (isNew) {
        this.ticketManager.addTicket(ticketInfo);
      } else {
        this.spinnerService.start();
        this.apiService.ticket.getTicket(ticketNo)
          .pipe(finalize(() => this.spinnerService.stop()))
          .subscribe(res => {
            this.ticketManager.addTicket(res, false);
          });
      }
    }
  }

  async ngOnInit() {
    await this.ticketManager.start();

    this.ticketManager.activeTicket$
      .pipe(takeWhile(() => this.alive))
      .subscribe(ticket => {
        if (!ticket) {
          return;
        }

        const els = document.querySelectorAll('.load-ticket');
        els.forEach((el: any) => {
          el.style.display = 'none';
        });

        const { ticketInfo, closeTab } = ticket || {};
        this.ticket = ticket;

        if (closeTab) {
          return;
        }

        if (this.loadComponents.find(f => f === ticketInfo?.ticketNo)) {
          const elementById = document.getElementById(ticketInfo.ticketNo) || document.getElementById(ticketInfo.previousTicketNo);
          if (elementById) {
            elementById.removeAttribute('style');
          }
          return;
        }

        setTimeout(() => {
          this.loadComponent();
        });
      });
  }

  ngOnDestroy() {
    this.alive = false;
  }

  loadComponent() {
    const { ticketNo, status } = this.ticket?.ticketInfo || {};

    const loadTicketNos = () => {
      this.loadComponents = this.ticketManager.tickets.map(m => m.ticketInfo?.ticketNo || 'ticket-list');
    };

    loadTicketNos();

    let dynamicComponent: ComponentRef<any>;

    dynamicComponent = this.container.createComponent(TicketEditComponent);

    this.renderer2.addClass(dynamicComponent.location.nativeElement, 'load-ticket');
    dynamicComponent.location.nativeElement.id = ticketNo || 'ticket-list';

    dynamicComponent.instance.ticketNo = ticketNo || 'ticket-list';
    dynamicComponent.instance?.destroy
      .subscribe(() => {
        dynamicComponent.destroy();
        loadTicketNos();
      });

  }
}
